module.exports = __webpack_public_path__ + "static/media/loader_gif_churchpad.dd046b46.gif";